import type { NextPage } from 'next';
import FAQ from 'containers/faq';
import Wrap from 'layouts/wrap';

const FAQPage: NextPage = () => (
  <Wrap>
    <FAQ />
  </Wrap>
);

export default FAQPage;
